export enum NodeInstanceStatus {
    Pending = 'Pending',
    Active = 'Active',
    Waiting = 'Waiting',
    Completed = 'Completed',
    Failed = 'Failed',
}
